type PawnProps = {
    className?: string;
};

export default function Pawn({ className }: PawnProps) {
    return (
        <svg
            className={className}
            viewBox="0 0 69 73"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M34.2497 14.6C30.8856 14.6 28.1608 17.5038 28.1608 21.0889C28.1608 22.5326 28.6023 23.8629 29.3481 24.9498C26.3798 26.7666 24.3553 30.1571 24.3553 34.0666C24.3553 37.3598 25.7861 40.296 28.0238 42.2264C23.4571 43.946 16.7441 51.2298 16.7441 64.0778H51.7553C51.7553 51.2298 45.0423 43.946 40.4756 42.2264C42.7133 40.296 44.1441 37.3598 44.1441 34.0666C44.1441 30.1571 42.1196 26.7666 39.1513 24.9498C39.8971 23.8629 40.3386 22.5326 40.3386 21.0889C40.3386 17.5038 37.6138 14.6 34.2497 14.6Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
}
